// CONFIGS
const urlConfig = {
	backend: 'https://backend-ai.klausurencoach.de',
}

export default urlConfig